import React from 'react';
import { ArrowUpRight, MapPin } from 'lucide-react';
import { PageHero } from './AboutPage';
import { projects } from '../mock';

const extra = [
  { title: 'Highway Solar Corridor', tag: 'Solar', img: 'https://images.unsplash.com/photo-1593941707874-ef25b8b4a92b', loc: 'Rajasthan' },
  { title: 'Mega EV Hub', tag: 'E-Mobility', img: 'https://images.pexels.com/photos/24376862/pexels-photo-24376862.jpeg', loc: 'Delhi NCR' },
  { title: 'Rooftop Solar Cluster', tag: 'EcoSolar', img: 'https://images.unsplash.com/photo-1593941707882-a5bba14938c7', loc: 'Tamil Nadu' },
];

const ProjectsPage = () => {
  const all = [...projects.map(p => ({ ...p, loc: 'PAN India' })), ...extra];
  return (
    <div>
      <PageHero title="Our Projects" subtitle="Real plants. Real impact. Real numbers." />
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {all.map((p, i) => (
            <div key={i} className="group relative rounded-3xl overflow-hidden shadow-md hover:shadow-2xl hover:shadow-emerald-100 transition-all duration-500">
              <div className="aspect-[4/5] overflow-hidden">
                <img src={p.img} alt={p.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-[#0b1a1a]/90 via-[#0b1a1a]/20 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-6 flex items-end justify-between">
                <div className="text-white">
                  <div className="text-xs font-semibold uppercase tracking-wider text-emerald-300">{p.tag}</div>
                  <div className="text-xl font-extrabold mt-1">{p.title}</div>
                  <div className="mt-1 flex items-center gap-1 text-xs text-slate-300"><MapPin className="w-3.5 h-3.5" />{p.loc}</div>
                </div>
                <div className="w-11 h-11 rounded-full bg-white text-emerald-600 grid place-items-center group-hover:bg-emerald-500 group-hover:text-white transition-colors">
                  <ArrowUpRight className="w-5 h-5" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ProjectsPage;
